import { useState, useEffect } from "react";
import { fetchCredential } from "../services/credentialService";

export const useCredential = (badgeId) => {
  const [credential, setCredential] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCredential = async () => {
      if (!badgeId) {
        setError("No badge ID provided");
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      const response = await fetchCredential(badgeId);

      if (response.status && response.records) {
        setCredential(response.records);
        setError(null);
      } else {
        setCredential(null);
        setError(response.message || "Credential not found");
      }

      setLoading(false);
    };

    loadCredential();
  }, [badgeId]);

  return { credential, loading, error };
};
